<template>
  <page :title="i18n.wallet" :showBack="false">
    <div class="wallet-warp" @click="selectedItem($event)">
      <div
        :class="
          selected
            ? selected.pId === -10
              ? 'wallet-balance selected'
              : 'wallet-balance'
            : 'wallet-balance'
        "
        v-if="
          user.pbalance > 0 ? (selected ? selected.pId === -10 : true) : false
        "
      >
        <div class="wallet-balance-warp">
          <div class="wallet-balance-label">{{ i18n.balance }}</div>
          <div class="wallet-balance-value">
            {{ user && user.pcurrencyName }}{{ (user && user.pbalance) || 0 }}
          </div>
          <div class="wallet-balance-label">
            {{ i18n.deposit }}: {{ user.pyajin }}
          </div>
        </div>
        <div class="wallet-balance-more">
          <img src="../../assets/imgs/wallet_more.png" />
        </div>
        <div class="Mask" :data-item="JSON.stringify({ pId: -10 })"></div>
      </div>
      <template v-for="item in list">
        <div
          :class="
            selected
              ? item.pDailiId === selected.pDailiId &&
                item.pCurrencyType === selected.pCurrencyType
                ? 'wallet-balance selected'
                : 'wallet-balance'
              : 'wallet-balance'
          "
          v-if="
            selected
              ? item.pDailiId === selected.pDailiId &&
                item.pCurrencyType === selected.pCurrencyType
              : true
          "
          :key="item.pId"
        >
          <div class="wallet-balance-warp">
            <div class="wallet-balance-label">{{ i18n.balance }}</div>
            <div class="wallet-balance-value">
              {{ item.pCurrencySymbol }}{{ item.pBalance || 0.0 }}
            </div>
            <div class="wallet-balance-label">
              {{ i18n.deposit }}: {{ item.pDepositAmount || 0 }}
            </div>
          </div>
          <div class="wallet-balance-more">
            <img src="../../assets/imgs/wallet_more.png" />
          </div>
          <div class="Mask" :data-item="JSON.stringify(item)"></div>
        </div>
      </template>
    </div>
    <div class="wallet-btn" v-if="selected !== null">
      <!-- <div v-if="selected.pId !== -10" @click="goRouter(`/wallet_in${query && query.price ? `?${querypath}` : ''}`)">
        <img src="../../assets/imgs/wallet_pull.png">
        <span>{{i18n.wallet_in}}</span>
      </div> -->
      <div @click="goRouter(`/wallet_out`)">
        <img src="../../assets/imgs/wallet_push.png" />
        <span>{{ i18n.wallet_out }}</span>
      </div>
    </div>
    <div class="wallet-cards">
      <div class="wallet-cards-label">{{ i18nPayment.payment_title }}</div>
      <template v-for="item in cardList">
        <div class="wallet-card-item" :key="item.pId">
          <img src="../../assets/imgs/icon_creditcard.png" />
          <span class="wallet-card-num">{{ item.pCardnumber }}</span>
          <span class="wallet-card-del" @click="deletePayCard(item)">{{
            i18nConfirm.deletecard
          }}</span>
        </div>
      </template>
      <div class="wallet-card-add btn" @click="onAddCard">
        {{ i18nPayment.add_payment_card }}
      </div>
    </div>
    <popup-warp v-model="isCreditcard">
      <div>
        <div class="wallet-card-input">
          <div id="wallet-card-element"></div>
        </div>
        <div class="btn wallet-card-bindbtn" @click="onBindCard">
          {{ i18nPayment.add_payment }}
        </div>
      </div>
    </popup-warp>
  </page>
</template>

<script>
import { USER_INFO, USER_WALLET, USER_CARD, REMOVE_CARD } from "../../apis/user.js"
import {
  PAYMODE,
  STRIPE_SAVE_CARD,
  STRIPE_SAVE_CARD_CONFIRM
} from "../../apis/payment.js"
import stripeMixin from "../../mixins/stripe"
import { PopupWarp } from "../../components/popup"
import { mapState } from "vuex"
export default {
  mixins: [stripeMixin],
  components: {
    PopupWarp
  },
  computed: {
    ...mapState(["user", "cabinet", "agentId"]),
    i18n() {
      return this.$t("mine")
    },
    i18nMsg() {
      return this.$t("msg")
    },
    i18nPayment() {
      return this.$t("payment")
    },
    i18nConfirm() {
      return this.$t("confirm")
    }
    // walletlist () {
    //   return this.list.filter(item => {
    //     return item.pBalance > 0
    //   })
    // },
  },
  data() {
    return {
      list: [],
      // list: [{
      //   pbalance: 1,
      //   pId: 1,
      //   pdepositAmount: 1,
      //   pcurrencySymbol: '$'
      // }, {
      //   pbalance: 2,
      //   pId: 2,
      //   pdepositAmount: 2,
      //   pcurrencySymbol: '$'
      // }],
      selected: null,
      query: null,
      querypath: window.location.href.split("?")[1],
      cardList: [], // 已保存的支付卡
      isCreditcard: false, // 绑卡弹层
      creditOrder: null, // 绑卡setup订单
      creditcard: null, // stripe elements实例
      saveCardPaymentId: "", // 代理商银行卡支付配置id
      publicKey: "" // 支付通道公钥
    }
  },
  methods: {
    selectedItem(e) {
      console.log(JSON.parse(e.target.dataset.item))
      let selecteddata = JSON.parse(e.target.dataset.item)
      if (
        this.selected &&
        selecteddata.pDailiId === this.selected.pDailiId &&
        selecteddata.pCurrencyType === this.selected.pCurrencyType
      ) {
        this.selected = null
        this.$store.commit("wallet", null)
        return
      }
      this.$store.commit("wallet", selecteddata)
      this.selected = selecteddata
    },
    loadUser() {
      this.$loading(true)
      this.$get(
        USER_INFO,
        {},
        (resp) => {
          this.$loading(false)
          if (resp.user) {
            this.$store.commit("user", resp.user)
            this.getWalletList()
          } else {
            this.$confirm({
              title: this.i18n.msg_fail_title,
              content: this.i18n.msg_fail_user,
              confirmText: this.i18nMsg.retry,
              cancelText: this.i18nMsg.cancel
            }).then(() => {
              this.loadUser()
            })
          }
        },
        (error) => {
          this.$loading(false)
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: this.i18nMsg.error,
            confirmText: this.i18nMsg.retry,
            cancelText: this.i18nMsg.cancel
          }).then(() => {
            this.loadUser()
          })
          console.log(error)
        }
      )
    },
    goRouter(path) {
      this.$router.push(path)
    },
    // ===== 保存卡管理(与 payment_card 页一致) =====
    // 获取代理商银行卡支付配置(绑卡所需的 paymentId/publicKey)
    getCardConfig() {
      this.$get(
        `${PAYMODE}?agentId=${this.agentId}`,
        {},
        (resp) => {
          const item = (resp.data || []).find(
            (v) => v.pPaymentType === "STRIPE_CARD"
          )
          if (item) {
            this.saveCardPaymentId = item.pId
            this.publicKey = item.publicKey || ""
            if (item.publicKey) this.loadStripeScript(item.publicKey)
          }
        },
        (error) => {
          console.log(error)
        }
      )
    },
    // 获取用户已保存的支付卡
    async getUserPayCard() {
      try {
        const { data = [] } = await this.$Request("get", USER_CARD, {
          qrcode: "",
          orderId: "",
          agentld: this.agentId
        })
        this.cardList = data || []
      } catch (error) {
        console.log(error)
      }
    },
    // 删除支付卡
    deletePayCard(v) {
      this.$confirm({
        title: this.i18nMsg.title,
        content: this.i18nMsg.deletecard,
        confirmText: this.i18nMsg.confirm,
        cancelText: this.i18nMsg.cancel
      }).then(() => {
        this.$loading(true)
        this.$post(
          `${REMOVE_CARD}/${v.pId}`,
          {},
          (resp) => {
            this.$loading(false)
            this.$toast(this.i18nMsg.success)
            this.getUserPayCard()
          },
          (error) => {
            this.$loading(false)
            console.log(error)
            this.$confirm({
              title: this.i18nMsg.title,
              content: this.i18nMsg.error,
              confirmText: this.i18nMsg.confirm,
              showCancel: false
            })
          }
        )
      })
    },
    // 添加支付卡:创建setup订单并弹出stripe卡输入框
    onAddCard() {
      if (!this.saveCardPaymentId) {
        this.$toast(this.i18nMsg.error)
        return
      }
      this.$loading(true)
      this.$post(
        `${STRIPE_SAVE_CARD}?paymentId=${this.saveCardPaymentId}`,
        {},
        (resp) => {
          this.$loading(false)
          this.creditOrder = resp.data
          this.isCreditcard = true
          this.$nextTick(() => this.onLoadCardElement())
        },
        (error) => {
          this.$loading(false)
          this.$confirm({
            title: this.i18nMsg.title,
            content: error,
            confirmText: this.i18nMsg.retry,
            cancelText: this.i18nMsg.cancel
          }).then(() => {
            this.onAddCard()
          })
        }
      )
    },
    // 挂载stripe卡输入框;禁用内嵌钱包,避免未注册域名下payframe失败导致输入框空白
    onLoadCardElement() {
      if (!window.stripe || !this.creditOrder || !this.creditOrder.clientSecret) {
        return
      }
      this.creditcard = window.stripe.elements({
        clientSecret: this.creditOrder.clientSecret,
        appearance: { theme: "stripe" }
      })
      const paymentElement = this.creditcard.create("payment", {
        wallets: { applePay: "never", googlePay: "never" }
      })
      paymentElement.mount("#wallet-card-element")
    },
    // 提交绑卡;纯卡无需跳转时直接回调,3DS等场景走return_url回跳到/wallet继续确认
    onBindCard() {
      const vm = this
      vm.$loading(true)
      window.stripe
        .confirmSetup({
          elements: vm.creditcard,
          confirmParams: {
            return_url: `${window.location.origin}#/wallet?paymentId=${this.saveCardPaymentId}&pmid=${this.creditOrder.paymentId}`
          }
        })
        .then((result) => {
          vm.$loading(false)
          if (result && result.error) {
            vm.$toast(result.error.message)
            return
          }
          const si = result && result.setupIntent
          if (si && (si.status === "succeeded" || si.status === "processing")) {
            vm.isCreditcard = false
            vm.onConfirmSaveCard(vm.saveCardPaymentId, vm.creditOrder.paymentId)
          }
        })
    },
    // 绑卡确认入库
    onConfirmSaveCard(pid, id) {
      this.$loading(true)
      this.$post(
        STRIPE_SAVE_CARD_CONFIRM,
        { paymentId: pid, paymentMethod: id },
        (resp) => {
          this.$loading(false)
          this.$toast(this.i18nMsg.success)
          this.getUserPayCard()
        },
        (error) => {
          this.$loading(false)
          this.$confirm({
            title: this.i18nMsg.title,
            content: error,
            confirmText: this.i18nMsg.retry,
            cancelText: this.i18nMsg.cancel
          }).then(() => {
            this.onConfirmSaveCard(pid, id)
          })
        }
      )
    },
    getWalletList() {
      this.$loading(true)
      this.$get(
        USER_WALLET,
        {},
        (resp) => {
          this.$loading(false)
          console.log(resp)
          this.list = resp.data
          if (this.list && this.list.length > 0) {
            this.selected = this.list[0]
            this.$store.commit("wallet", this.selected)
          } else {
            this.list = [{
              pCurrencySymbol: '',
              pBalance: 0,
              pDepositAmount: 0
            }]
            this.selected = {
              pCurrencySymbol: '',
              pBalance: 0,
              pDepositAmount: 0
            }
            this.$store.commit("wallet", this.selected)
          }
        },
        (error) => {
          this.$loading(false)
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: this.i18nMsg.error,
            confirmText: this.i18nMsg.retry,
            cancelText: this.i18nMsg.cancel
          }).then(() => {
            this.getWalletList()
          })
          console.log(error)
        }
      )
    }
  },
  created() {
    this.query = this.$route.query
    // 绑卡3DS等回跳:携带paymentId+pmid,直接确认入库
    const { paymentId, pmid } = this.$route.query
    if (paymentId && pmid) {
      this.onConfirmSaveCard(paymentId, pmid)
    }
    this.loadUser()
    this.getCardConfig()
    this.getUserPayCard()
  }
}
</script>

<style lang="less">
.wallet-warp {
  .selected {
    border: solid 2px #309df7;
    border-top: solid 2px #309df7 !important;
  }
  .Mask {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
  }
  .wallet-balance {
    position: relative;
    margin: 40px;
    // background: linear-gradient(90deg,#EBD460 0%,#E5BE53 100%);
    background-color: rgba(255, 255, 255, 0.4);
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    padding: 40px 60px 20px;
    color: #fff;
    display: flex;
    align-items: center;
    &-warp {
      flex: 1;
    }
    &-label {
      font-size: 32px;
    }
    &-value {
      font-size: 70px;
      font-weight: bold;
    }
    &-more {
      & img {
        width: 20px;
        height: 30px;
        display: block;
      }
    }
  }
}

.wallet-cards {
  margin: 20px 40px 40px;
  &-label {
    font-size: 32px;
    color: #fff;
    padding: 20px 0;
  }
  .wallet-card-item {
    display: flex;
    align-items: center;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 20px;
    padding: 26px 30px;
    margin-bottom: 20px;
    img {
      width: 48px;
      height: 48px;
      margin-right: 20px;
    }
    .wallet-card-num {
      flex: 1;
      color: #fff;
      font-size: 30px;
    }
    .wallet-card-del {
      color: #fc0d1b;
      font-size: 28px;
      padding: 4px 12px;
    }
  }
  .wallet-card-add {
    margin-top: 10px;
  }
}

.wallet-card-input {
  margin: 48px 48px 80px;
  padding: 20px;
  border-radius: 20px;
  border: 1px solid #e4e7ed;
}

.wallet-card-bindbtn {
  margin: 48px;
}

.wallet-btn {
  display: flex;
  padding: 20px 40px;
  & div {
    flex: 1;
    height: 72px;
    line-height: 72px;
    border-radius: 10px;
    text-align: center;
    border: 2px solid #333333;
    font-size: 28px;
    font-weight: 500;
    color: #333333;
    margin: 0 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #FBD20C;
  }
  & img {
    width: 40px;
    height: 40px;
    display: block;
  }
  & span {
    padding-left: 15px;
  }
}
</style>
